import { valibotResolver } from '@hookform/resolvers/valibot';
import { array, email, maxLength, minLength, nonEmpty, number, object, pipe, string, trim } from 'valibot';

import type { IFile } from '@model/file';
import type { IUser } from '@model/userProfile';

export const CONTACT_SUPPORT_FIELDS = {
  FULL_NAME: 'fullName',
  EMAIL_ADDRESS: 'email',
  DESCRIPTION: 'description',
  ATTACHMENTS: 'attachments',
} as const;

export interface IContactSupportForm {
  fullName: string;
  email: string;
  description: string;
  attachments: IFile[];
}

export const schemaContactSupport = valibotResolver(
  object({
    [CONTACT_SUPPORT_FIELDS.FULL_NAME]: pipe(string(), nonEmpty('This field is required.')),
    [CONTACT_SUPPORT_FIELDS.EMAIL_ADDRESS]: pipe(
      string(),
      trim(),
      nonEmpty('This field is required.'),
      email('Enter correct email'),
      maxLength(255, 'Your email is too long.'),
    ),
    [CONTACT_SUPPORT_FIELDS.DESCRIPTION]: pipe(
      string(),
      nonEmpty('This field is required.'),
      minLength(10, 'Your description is too short.'),
    ),
    [CONTACT_SUPPORT_FIELDS.ATTACHMENTS]: array(
      object({ extension: string(), name: string(), size: number(), url: string() }),
    ),
  }),
);

export const getContactSupportDefaultValues = (user?: IUser) => {
  return {
    [CONTACT_SUPPORT_FIELDS.FULL_NAME]: user?.full_name || '',
    [CONTACT_SUPPORT_FIELDS.EMAIL_ADDRESS]: user?.email || '',
    [CONTACT_SUPPORT_FIELDS.DESCRIPTION]: '',
    [CONTACT_SUPPORT_FIELDS.ATTACHMENTS]: [],
  };
};
